import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngrx/store';
import {setConvocationDateAction, setConvocationTimeAction, setInviteDateAction, setInviteTimeAction} from '../../states/creationActions';

@Component({
  selector: 'app-communications',
  templateUrl: './communications.component.html',
  styleUrls: ['./communications.component.less', '../poll-creation-form/poll-creation-form.component.less', '../../shared/common.less']
})
export class CommunicationsComponent implements OnInit {
  @Output() sendLive = new EventEmitter<string>();
  @Input() invitations: boolean;
  launchValid = false;
  isValidInviteTime = true;
  isValidInviteDate = true;
  displayConvocations = false;
  displayInvitations = false;
  initialInviteDate: string;
  initialInviteTime: string;
  convocationDate: string;
  convocationTime: string;
  inviteDate: string;
  inviteTime: string;

  constructor(private store: Store) {}

  setupConvocations() {
    const checkbox = document.getElementById('convocation-check') as HTMLInputElement;
    this.displayConvocations = checkbox.checked;
    if (!checkbox.checked) {
      this.store.dispatch(setConvocationDateAction({convocationDate: null}));
      this.store.dispatch(setConvocationTimeAction({convocationTime: null}));
    }
  }

  setupInvitations() {
    const checkbox = document.getElementById('invitations-check') as HTMLInputElement;
    this.displayInvitations = checkbox.checked;
    if (!checkbox.checked) {
      this.store.dispatch(setInviteDateAction({inviteDate: this.initialInviteDate}));
      this.store.dispatch(setInviteTimeAction({inviteTime: this.initialInviteTime}));
    }
  }

  onInviteDate(event) {
    this.store.dispatch(setInviteDateAction({inviteDate: event.target.value}));
  }

  onInviteTime(event) {
    this.store.dispatch(setInviteTimeAction({inviteTime: event.target.value}));
  }

  onConvocationDate(event) {
    this.store.dispatch(setConvocationDateAction({convocationDate: event.target.value}));
  }

  onConvocationTime(event) {
    this.store.dispatch(setConvocationTimeAction({convocationTime: event.target.value}));
  }

  goLive() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.sendLive.emit('live');
  }

  ngOnInit() {
    this.store.select((state: any) => state.creation.poll).subscribe(res => {
      const eventDate = new Date(`${res.startDate} ${res.startTime}`);
      let eventMillis = eventDate.getTime() - 1000 * 60 * 30;
      if (eventMillis < new Date().getTime()) {
        eventMillis = Math.min((new Date().getTime() + 1000 * 60 * 5), new Date(`${res.startDate} ${res.startTime}`).getTime());
      }
      const updatedDate = new Date(eventMillis);
      this.initialInviteDate = res.startDate;
      this.initialInviteTime = updatedDate.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
      this.launchValid = res.resolutions.length > 0 || res.choices.length > 0;
      if (this.convocationDate === undefined && res.convocationDate != null) {
        const checkboxConv = document.getElementById('convocation-check') as HTMLInputElement;
        checkboxConv.checked = true;
        this.setupConvocations();
        this.convocationDate = res.convocationDate;
      }
      if (res.convocationDate != null && this.convocationTime === undefined && res.convocationTime) {
        this.convocationTime = res.convocationTime;
      }
      if (this.inviteDate === undefined && res.inviteDate != null) {
        const inviteBox = document.getElementById('invitations-check') as HTMLInputElement;
        inviteBox.checked = true;
        this.setupInvitations();
        this.inviteDate = res.inviteDate;
      }
      if (res.inviteDate != null && this.inviteTime === undefined && res.inviteTime) {
        this.inviteTime = res.inviteTime;
      }
    });
  }
}
